<h3 class="mt-0 mb-12" *ngIf="titleTranslationKey">{{ titleTranslationKey | translate }}</h3>

<mat-radio-group
    [(ngModel)]="filterMode"
    (ngModelChange)="onFilterModeChange()"
    class="radio-group mb-12"
>
    <mat-radio-button value="like">{{ 'GENERAL.LABEL.CONTAINS' | translate }}</mat-radio-button>
    <mat-radio-button value="eq">{{ 'GENERAL.LABEL.IS_EXACTLY' | translate }}</mat-radio-button>
</mat-radio-group>

<mat-form-field class="w-100-p">
    <mat-label>{{ 'GENERAL.PROPERTY.VALUE' | translate }}</mat-label>
    <input
        matInput
        [(ngModel)]="inputValue"
        (keydown.enter)="$event.preventDefault(); addToList()"
    />
</mat-form-field>

<div fxLayoutAlign="end center">
    <app-flat-button
        [label]="'GENERAL.BUTTON.ADD'"
        (onClick)="addToList()"
        [disabled]="!hasAddableText"
    ></app-flat-button>
</div>
